import { endpoints } from '../../../api/domains/endpoints';
import api from '../../../api';

export async function getTranslationsAPI ({  apiKey, traceId, store, locale}) {
    return await api.get(
        `${endpoints().translation}?apiKey=${apiKey}&locale=${locale}`,
        {},  
        { traceId },
        store,
    );
}

export async function getStaticTranslationsAPI ({  traceId, store, locale}) {
    return await api.get(
        `${endpoints().staticTranslation}?locale=${locale}`,
        {}, /* body */
        { traceId }, /* options */
        store,
    );  
}

 